import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import 'floating-vue/dist/style.css'

// Highcharts modules — cargar una sola vez globalmente
import Highcharts from 'highcharts'
import HighchartsHeatmap from 'highcharts/modules/heatmap'
HighchartsHeatmap(Highcharts)

import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import "toastify-js/src/toastify.css";
import "@vueform/multiselect/themes/default.css";
import { VueSignaturePad } from 'vue-signature-pad';

// FilePond labels — el idioma se elige por país/deployment, no por usuario,
// así que basta setearlos una vez al boot leyendo el locale activo.
import { setOptions as setFilePondOptions } from 'filepond';
const fpLabels = i18n.global.tm('filepond');
if (fpLabels && typeof fpLabels === 'object') {
    setFilePondOptions(fpLabels);
}


import {
    // Directives
    vTooltip,
    vClosePopper,
    // Components
    Dropdown,
    Tooltip,
    Menu
} from 'floating-vue'

const app = createApp(App)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.use(i18n)

//app.provide('icons', icons)
app.component('CIcon', CIcon)
app.component('EasyDataTable', Vue3EasyDataTable);
app.component("VueSignaturePad", VueSignaturePad);

app.directive('tooltip', vTooltip)
app.directive('close-popper', vClosePopper)

app.component('VDropdown', Dropdown)
app.component('VTooltip', Tooltip)
app.component('VMenu', Menu)

app.mount('#app')
